import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export const useIsPremiumTemplate = () => {
  const template = useContext(AppDataContext).payloadToSSR.template;

  return template === 'PostPagePremium';
};
